var poll_default = {
  "fontElementMap": "_1Jui1",
  "container": "wrG-s",
  "fullscreen": "bQmhB",
  "background_overlay": "tw-GK",
  "with_image": "xwvYZ",
  "options": "xia24",
  "webview": "r5CDw",
  "grid": "W9BQn",
  "option": "rAJs1",
  "cta_button": "swVbE",
  "add_option": "_4j-cc",
  "see_more": "ER9pC",
  "list": "xV9-q",
  "column": "AZGuY",
  "additional_note": "YPLyM",
  "spinner": "kgpPq",
  "spin": "sm9NC",
  "shown": "ppjtM",
  "error": "ZlTxb"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
